import React, { useState } from 'react'
import { Blacked, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper } from '../styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Input, message } from 'antd'
import { ChromePicker } from 'react-color';
import API from 'utils/api';
import { useToken } from 'app/hooks';
import { useStatusList } from 'CRM/hooks/GetStatusList';
import { usePathList } from 'CRM/hooks/GetPathList';
import {useIsMobile} from "../IsMobile";

export const PathEdit = ({ setIsEdit, data }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const { mutate } = usePathList();
  const [name, setName] = useState(data?.name || '');
  const [desc, setDesc] = useState(data?.desc || '');

  const clickSubmit = () => {
    const shouldEdit = window.confirm(`수정하실 내용이 맞습니까? \n 방문경로: ${name} \n 설명: ${desc}`);
    if(shouldEdit) {
      if(name == '') {
        message.error('방문경로는 필수 입력입니다.')
      } else {
        API.put('/system/accesspath/' + data?.id, token + '', {
          datas: {
            name: name,
            desc: desc
          }
        })
        .then((res: any) => {
          if (res.result.success) {
            message.success('수정되었습니다');
            mutate();
            setIsEdit(false);
          }
        })
        .catch((err: any) => {})
      }
    }
  }

  return (
    <>
      <Blacked onClick={() => setIsEdit(false)} />
      <ModalWrapper IsMobile={IsMobile}>
        <ModalHeader>
          <Icon onClick={() => setIsEdit(false)}><FaChevronLeft /></Icon>
          <ModalTitle>방문경로 수정</ModalTitle>
          <ModalSubmit onClick={clickSubmit}>저장</ModalSubmit>
        </ModalHeader>
        <ModalContent>
          <ModalInput>
            <label htmlFor='name'>방문경로명 *</label>
            <Input id='name' type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder='상태를 입력해주세요.' />
          </ModalInput>
          <ModalInput>
            <label htmlFor='desc'>설명</label>
            <Input id='desc' type="text" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder='설명을 입력해주세요.' />
          </ModalInput>
        </ModalContent>
      </ModalWrapper>
    </>
  )
}

export default React.memo(PathEdit);